import Axios from 'axios';
import { plato_api_grade_question_answer_path } from '@/modules/routes';
import { ScoreData } from '@/components/shared/Grading/Navigation/BulkGrading/types';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import { isAnswered, showsScoreInput } from '@/components/staffer/Grading/utils';

// Bulk-gradable questions for the student currently shown in Grade By Student: the manually graded
// questions whose score input the page actually renders and lets the teacher edit.
const useBulkGradeRows = (): ScoreData[] => {
  const {
    assignment,
    isAssessment,
    questionAnswers,
    student,
    submissionForStudent,
  } = useGradingStore();

  if (!assignment || !student || !questionAnswers) return [];
  if (isAssessment() && submissionForStudent(student.id)?.submitted_at == null) return [];

  const answerFor = (questionId: number) => questionAnswers.find(qa => qa.question_id === questionId);

  return assignment.questions
    .filter(question => (
      !question.auto_gradable
      && question.type !== 'PromptOnly'
      && showsScoreInput(assignment, question)
      // AIDEV-NOTE: grading an assessment question with no answer row creates one with no exercise
      // result, and QuestionAnswer#grade! then silently skips it. Grade By Question skips them too.
      && (!isAssessment() || !!answerFor(question.id))
    ))
    .map((question) => {
      const questionAnswer = answerFor(question.id);

      return {
        answerID: questionAnswer?.id,
        canEdit: true,
        containerClass: '',
        maxScore: question.points,
        promptOnly: false,
        questionAnswered: isAnswered(questionAnswer),
        questionAutoGraded: false,
        questionId: question.id,
        updateURL: plato_api_grade_question_answer_path(student.id, {
          assignment_id: assignment.id,
          assignment_type: assignment.assignment_details.exercise_type,
          question_answer_id: questionAnswer?.id,
          question_id: question.id,
        }),
      };
    });
};

export const postScore = (row: ScoreData, score: number | string) => (
  Axios.post(row.updateURL, { score }).then((res) => {
    if (!res.data.success) throw new Error(`Score was not saved for question ${row.questionId}`);
  })
);

export default useBulkGradeRows;
